import React, { useContext } from "react";
import LoginHeader from '../../components/Headers/LoginHeader';
import LoginFooter from '../../components/Footers/LoginFooter';
import AdminHeader from '../../components/Headers/AdminHeader';
import BusinessDashboard from '../../components/Dashboard/BusinessDashboard';
import OfficerDashboard from '../../components/Dashboard/OfficerDashboard';
import AdminDashboard from "../../components/Dashboard/Admin/AdminDashboard";
import { UserContext } from '../../context/User';

const DashboardPage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;

  return (
    <>  
      {role === "admin" ? <AdminHeader /> : <LoginHeader />}
      <main>
        {role === "business" && <BusinessDashboard role={role} />}
        {role === "officer" && <OfficerDashboard role={role} />}
        {role === "admin" && <AdminDashboard role={role} />}
      </main>
      <LoginFooter />
    </>
  );
}

export default DashboardPage;